import { render, staticRenderFns } from "./myclassroom.vue?vue&type=template&id=06fd377c&scoped=true&"
import script from "./myclassroom.vue?vue&type=script&lang=js&"
export * from "./myclassroom.vue?vue&type=script&lang=js&"
import style0 from "./myclassroom.vue?vue&type=style&index=0&id=06fd377c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd377c",
  null
  
)

export default component.exports